import React, { useEffect, useRef } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import Dialog from '@mui/material/Dialog';
import { Divider, Stack, Typography, Box, Button } from '@mui/material';
import DialogContent from '@mui/material/DialogContent';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { setIsLoading, setSnackBar } from '../../../store/globalSlice';
import { useDispatch } from 'react-redux';
import ApiClient from '../../../config/api';
import { submitStatusChange } from './submitStatusChange';

const GetParcel = ({
  openGetParcel,
  setOpenGetParcel,
  selectedTask,
  selectedParcel,
  selectedStatus,
  location,
  setOpenDetail,
}) => {
  const signatureRef = useRef(null);
  const completedIds = useRef(new Set());
  const submitting = useRef(false);
  useEffect(() => {
    completedIds.current = new Set();
  }, [openGetParcel]);
  const dispatch = useDispatch();
  const api = ApiClient();

  const handleSaveSignature = async () => {
    if (submitting.current) return;
    if (signatureRef.current) {
      submitting.current = true;
      const dataURL = signatureRef.current.toDataURL();
      try {
        dispatch(setIsLoading(true));
        await submitStatusChange({
          api,
          scope: openGetParcel,
          selectedTask,
          selectedParcel,
          completedIds: completedIds.current,
          data: {
            signature: dataURL,
            status: selectedStatus?.key,
            lng: location?.coords.longitude || 0,
            lat: location?.coords.latitude || 0,
          },
        });
        setOpenGetParcel('');
        setOpenDetail(false);
      } catch (error) {
        dispatch(
          setSnackBar({ message: error?.response?.data?.message || error.message, severity: 'error' })
        );
        console.error('Error saving signature:', error);
      } finally {
        submitting.current = false;
        dispatch(setIsLoading(false));
      }
    }
  };

  return (
    <React.Fragment>
      <Dialog
        onClose={() => setOpenGetParcel('')}
        aria-labelledby="customized-dialog-title"
        open={Boolean(openGetParcel)}
        maxWidth="sm"
        fullWidth={true}
        fullScreen={true}
      >
        <Stack
          sx={{
            position: 'sticky',
            pt: 2,
            top: 0,
            zIndex: 1,
          backgroundColor: 'background.paper',
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-end',
            alignItems: 'center',
          }}
        >
          <Typography fontSize={20} fontWeight={600} textAlign={'right'}>
            {openGetParcel?.label || 'دریافت مرسوله'}
          </Typography>
          <KeyboardBackspaceIcon
            className={'clickable'}
            sx={{
              transform: 'rotate(180deg)',
              cursor: 'pointer',
              marginRight: '8px',
              marginLeft: '8px',
              fontSize: '24px',
            }}
            onClick={() => {
              setOpenGetParcel('');
            }}
          />
        </Stack>
        <Divider
          sx={{
            width: '100%',
            marginTop: '10px',
          }}
        />
        <Typography
          textAlign={'right'}
          justifyContent={'flex-end'}
          variant="caption"
          display={'flex'}
          padding={2}
          paddingLeft={3}
        >
          . سند دریافت مرسوله را ثبت نمایید
        </Typography>
        <DialogContent sx={{ pt: '0px', mt: 2 }}>
          <Typography variant="subtitle1" gutterBottom textAlign={'end'}>
            محل ثبت امضا
          </Typography>
          <Box
            sx={{
              border: '1px solid',
              borderColor: 'divider',
              borderRadius: 2,
              p: 0,
            }}
          >
            <SignatureCanvas
              ref={signatureRef}
              penColor="black"
              canvasProps={{
                width: window.innerWidth - 50,
                className: 'signature-canvas',
                height: `${window.innerHeight - 250}px`,
              }}
            />
          </Box>
          <Stack
            direction="row"
            spacing={2}
            justifyContent="center"
            sx={{ mt: 2 }}
          >
            <Button
              variant="contained"
              sx={{ color: 'primary.contrastText' }}
              fullWidth
              onClick={handleSaveSignature}
            >
              ثبت
            </Button>
          </Stack>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
};

export default GetParcel;
